import React from 'react';

const Icon16Orientation2ReclinerRight = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <rect
      x="291.63"
      y="283.66"
      width="216.75"
      height="216.75"
      fill="transparent"
    />
    <path
      d="M508.37,231.42h216.75v369.66c0,7.98-6.47,14.45-14.45,14.45h-187.85c-7.98,0-14.45-6.47-14.45-14.45V231.42h0Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M725.12,231.42h32.67c5.07,0,9.18,4.11,9.18,9.18v250.64c0,5.07-4.11,9.18-9.18,9.18h-23.49c-5.07,0-9.18-4.11-9.18-9.18V231.42h0Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <rect
      x="291.63"
      y="231.42"
      width="216.75"
      height="52.25"
      fill="transparent"
      stroke="currentColor"
      strokeDasharray="15"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="6"
    />
    <rect
      x="74.88"
      y="283.66"
      width="216.75"
      height="216.75"
      fill="transparent"
    />
    <path
      d="M42.2,231.42h32.67v259.82c0,5.07-4.11,9.18-9.18,9.18h-23.49c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <rect
      x="74.88"
      y="231.42"
      width="216.75"
      height="52.25"
      fill="transparent"
      stroke="currentColor"
      strokeDasharray="15"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="6"
    />
    <rect
      x="508.37"
      y="231.42"
      width="216.75"
      height="52.25"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M291.63,500.41h216.75v43.25c0,4.97-4.03,9-9,9h-198.75c-4.97,0-9-4.03-9-9v-43.25h0Z"
      fill="transparent"
      stroke="currentColor"
      strokeDasharray="15"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="6"
    />
    <path
      d="M83.88,500.41h198.75c4.97,0,9,4.03,9,9v43.25H74.88v-43.25c0-4.97,4.03-9,9-9Z"
      transform="translate(366.5 1053.07) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeDasharray="15"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="6"
    />
    <line
      x1="291.63"
      y1="283.66"
      x2="291.63"
      y2="500.41"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
  </svg>
);

export default Icon16Orientation2ReclinerRight;
